/**
 * Uzbek strings of the agent's message wording, its job shares and the platform's system values
 * (Wave 2). Spread into `uz`, so a key here is a `TranslationKey` like any other.
 */
export const uzAgentW2 = {
  "ruleMessage.edit": "Matn",
  "ruleMessage.title": "Xabar matni: {name}",
  "ruleMessage.uz": "O'zbekcha",
  "ruleMessage.ru": "Ruscha",
  "ruleMessage.hint":
    "{placeholder} mijozning ismi bilan almashadi. Mijoz ruscha yozgan bo'lsa, ruscha matn ketadi. Bo'sh qoldirsangiz, Kapitan matni ishlatiladi.",
  "ruleMessage.saved": "Matn saqlandi",
  "ruleMessage.failed": "Matnni saqlab bo'lmadi",
  "ruleMessage.loadFailed": "Standart matnni yuklab bo'lmadi.",
  "ruleMessage.retry": "Qayta urinish",
  "ruleMessage.cancel": "Bekor qilish",
  "ruleMessage.save": "Saqlash",

  "jobShare.title": "Kunlik kredit ulushi",
  "jobShare.hint":
    "Bu vazifa kunlik kredit chegarasining necha foizini sarflashi mumkin. Bo'sh bo'lsa, alohida chegara yo'q. Ulush tugasa, suhbat operatorga o'tadi.",
  "jobShare.label": "Ulush, %",
  "jobShare.save": "Saqlash",
  "jobShare.saved": "Ulush saqlandi",
  "jobShare.invalid": "1 dan 100 gacha butun son kiriting yoki bo'sh qoldiring.",

  "gateRefusals.title": "AI nega ishlamadi",

  "platformSystem.title": "Tizim sozlamalari",
  "platformSystem.empty": "Sozlamalar yo'q.",
  "platformSystem.setting": "Sozlama",
  "platformSystem.value": "Qiymat",
  "platformSystem.save": "Saqlash",
  "platformSystem.saved": "Sozlama saqlandi",
  "platformSystem.failed": "Sozlamani saqlab bo'lmadi",
} as const;
